/**
 * @generated SignedSource<<8bf1ab4f24d44ac2b801b7a51a685a6c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type BuildPageRunIdQuery$variables = {
  buildLocator: string;
  skip: boolean;
};
export type BuildPageRunIdQuery$data = {
  readonly build?: {
    readonly id: number | null | undefined;
  } | null | undefined;
};
export type BuildPageRunIdQuery = {
  response: BuildPageRunIdQuery$data;
  variables: BuildPageRunIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "buildLocator"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "buildLocator",
    "variableName": "buildLocator"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BuildPageRunIdQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "Build",
            "kind": "LinkedField",
            "name": "build",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BuildPageRunIdQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "Build",
            "kind": "LinkedField",
            "name": "build",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "_id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "9216197db9a7501cbe10153cdc10e162",
    "id": null,
    "metadata": {},
    "name": "BuildPageRunIdQuery",
    "operationKind": "query",
    "text": "query BuildPageRunIdQuery(\n  $buildLocator: String!\n  $skip: Boolean!\n) {\n  build(buildLocator: $buildLocator) @skip(if: $skip) {\n    id\n    _id\n  }\n}\n"
  }
};
})();

(node as any).hash = "23ff6bceb950d3ab068b13292c48f3b6";

export default node;
